package com.wintermar.inspection.feature.presentation.inspection.widget

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.wintermar.inspection.core.ui.component.TextBodySmall
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.feature.domain.model.template.TemplateOptionModel
import com.wintermar.inspection.feature.presentation.inspection.answer.widget.choice_answer.contentColor
import com.wintermar.inspection.graphql.type.InspectionAnswerType

@Composable
fun AnswerBadge(
    answerType: InspectionAnswerType,
    answerOptionId: String,
    templateOptions: List<TemplateOptionModel>,
    dimension: AppDimension = LocalAppTheme.current.dimension
) {
    val option = templateOptions.find { it.id == answerOptionId }
    val color = answerType.contentColor(
        orderPosition = option?.order ?: 0
    )

    Column(
        modifier = Modifier
            .background(
                color = color.backgroundColor,
                shape = RoundedCornerShape(dimension.radius.lg)
            )
            .border(
                width = 1.dp,
                color = color.borderColor,
                shape = RoundedCornerShape(dimension.radius.lg)
            )
            .padding(
                vertical = dimension.spacing.space1,
                horizontal = dimension.spacing.space3
            )
    ) {
        TextBodySmall(
            text = option?.label ?: "",
            bold = true,
            color = { color.textColor }
        )
    }
}
